import React from 'react'
import * as PropTypes from 'prop-types'

interface ContactButtonProps {
  url: string
}

export default function ContactButton (props: ContactButtonProps): React.ReactElement {
  return <a href={props.url} className='pro-button primary pro-small contact-us-button' target='_blank' rel='noreferrer'>Contact Us</a>
}

ContactButton.propTypes = {
  url: PropTypes.string.isRequired
}
